import { FC, ReactElement } from 'react';

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import { Box, Typography } from '@mui/material';

import ZendeskLoader from './ZendeskLoader';

const ZendeskButton: FC<{ iconOnly?: boolean }> = ({ iconOnly = false }) => {
  const icon = <ChatBubbleOutlineIcon color="primary" />;

  const generateUI = (icon: ReactElement): ReactElement => {
    if (iconOnly) return icon;
    return (
      <Typography
        sx={{
          color: 'primary.dark',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box component="span" sx={{ marginRight: '0.5rem' }}>
          SUPPORT
        </Box>{' '}
        {icon}
      </Typography>
    );
  };

  return (
    <ZendeskLoader
      loadingIndicator={generateUI(
        <Typography variant="body1">Loading...</Typography>,
      )}
    >
      {generateUI(icon)}
    </ZendeskLoader>
  );
};

export default ZendeskButton;
